import * as Yup from 'yup'
import { Form, Col, Row } from 'react-bootstrap'
import { CustomFormControl, CustomFormSelect } from '../../../../StyledComponents';
import { checkRequiredText } from '../ValidationRules';
import { Options } from '../SelectOptions';
import { parse } from 'date-fns/parse'
import { isDate } from 'date-fns/fp'
export const characterRestrictionRegExp = /^[a-zA-Z0-9äöüÄÖÜßé '.,!?&_/\-()]+$/i;

function parseDateString(value, originalValue) {
    const parsedDate = isDate(originalValue) || originalValue == null
        ? originalValue
        : parse(originalValue, "yyyy-MM-dd", new Date());

    return parsedDate;
}
const today = new Date();

export const Schema = (settings) => Yup.object().shape({
    placeOfBirth: Yup.string()
        .nullable()
        .when("settings.isUnicode", {
            is: () => !settings.isUnicode,
            then: Yup.string().matches(characterRestrictionRegExp, "Bitte geben Sie einen gültigen Wert an")
        })
        .max(30,"Es können maximal 30 Zeichen eingegeben werden"),
    dateOfBirth: Yup.date()
        .nullable()
        .min(new Date(1900, 1, 1), "Geburtsdatum muss größer als 01.01.1900 sein.")
        .typeError("Bitte geben Sie einen gültigen Wert an")
        .transform(parseDateString).max(today, "Geburtsdatum kann nicht in der Zukunft liegen")
    ,
    salutation: Yup.string().required("Angabe ist erforderlich"),
});

export const PersonalDataSubForm = ({ form: { values, handleBlur, handleChange, touched, errors }, ...props }) => {
    const { colors, settings } = props;
    return (
        <>
            <Row className="mb-3">
                <Form.Group as={Col} md={6} controlId="formPlaceOfBirth">
                    <Form.Label>Geburtsort</Form.Label>
                    <CustomFormControl
                        colors={colors}
                        placeholder="Geburtsort eingeben"
                        type="text"
                        name="placeOfBirth"
                        value={values.placeOfBirth}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        onInput={handleBlur}
                        isValid={touched.placeOfBirth && !errors.placeOfBirth}
                        isInvalid={touched.placeOfBirth && errors.placeOfBirth}
                        maxLength={settings.textInputLimit}
                    />
                    <Form.Control.Feedback type="invalid">
                        {errors.placeOfBirth}
                    </Form.Control.Feedback>
                </Form.Group>
                <Form.Group as={Col} md={3} controlId="formDateOfBirth">
                    <Form.Label>Geburtsdatum</Form.Label>
                    <CustomFormControl
                        colors={colors}
                        placeholder="Geburtsdatum eingeben"
                        type="date"
                        name="dateOfBirth"
                        value={values.dateOfBirth}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isValid={touched.dateOfBirth && !errors.dateOfBirth}
                        isInvalid={touched.dateOfBirth && errors.dateOfBirth}
                        maxLength={settings.textInputLimit}
                    />
                    <Form.Control.Feedback type="invalid">
                        {errors.dateOfBirth}
                    </Form.Control.Feedback>
                </Form.Group>
                <Form.Group as={Col} md={3} controlId="formSalutation">
                    <Form.Label>Geschlecht*</Form.Label>
                    <CustomFormSelect
                        colors={colors}
                        name="salutation"
                        value={values.salutation}
                        isValid={touched.salutation && !errors.salutation}
                        isInvalid={touched.salutation && errors.salutation}
                        onChange={handleChange}
                        onBlur={handleBlur}
                    >
                        <option value="">Bitte auswählen...</option>
                        {Options.Salutation.map((item, index) => <option key={index} value={item.value}>{item.text}</option>)}
                    </CustomFormSelect>
                    <Form.Control.Feedback type="invalid">
                        {errors.salutation}
                    </Form.Control.Feedback>
                </Form.Group>
            </Row>
        </>
    );
};